/* ============================================================
   TAMWAJ — خصم العروض داخل السلة

   Releasit ينشئ الطلب بنفسه من الأسعار الأصلية ولا يمرّ على سلة
   شوبيفاي. فلو تُرك خصم السلة لشوبيفاي، لظهر رقم في السلة ورقم
   آخر في نموذج الطلب. لذلك مصدر الخصم واحد: جدول العروض الذي
   يسافر مع كل سطر كخاصية مخفية _tamwaj_tiers.

   كل الحسابات على original_line_price — السعر قبل أي خصم — حتى
   يطابق ما يبنيه Releasit تمامًا، وحتى لا يقع خصم فوق خصم لو
   بقي في الجلسة كوكي كود قديم.
   ============================================================ */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  /* نُصلح الصيغة عند المصدر: money_format في المتجر ما زال
     "Dhs. {{amount}}"، و tamwaj-money.js يصحّحه لاحقًا بمراقب تغيّر.
     الاعتماد عليه يعني وميض "Dhs." قبل أن يُستبدل، فنكتب AED ابتداءً. */
  var MONEY = ((window.theme && window.theme.moneyFormat) || 'AED {{amount}}')
    .replace(/Dhs\.?/i, 'AED');

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MONEY.replace(/\{\{\s*amount[^}]*\}\}/, parts.join('.'));
  }

  /* وضع التقريب ملحق بعد | مثل: "1:0,2:15,3:25|9" */
  function parseMode(raw) {
    if (!raw) return 'none';
    var parts = String(raw).split('|');
    return parts.length > 1 ? parts[1] : 'none';
  }

  function priced(cents, mode) {
    return (window.TamwajPricing && window.TamwajPricing.round)
      ? window.TamwajPricing.round(cents, mode)
      : Math.round(cents);
  }

  /* "1:0,2:15,3:25|9" → [{qty,discount}] مرتّبًا تنازليًا */
  function parseTiers(raw) {
    if (!raw) return [];
    return String(raw).split('|')[0].split(',').map(function (pair) {
      var p = pair.split(':');
      return { qty: parseInt(p[0], 10) || 0, discount: parseFloat(p[1]) || 0 };
    }).filter(function (t) { return t.qty > 0; })
      .sort(function (a, b) { return b.qty - a.qty; });
  }

  function tierFor(tiers, qty) {
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].qty) return tiers[i];
    }
    return null;
  }

  /* الخصم لكل سطر على حدة: «قطعتان» تعني قطعتين من المنتج نفسه،
     لا قطعة من هذا وقطعة من ذاك. */
  function totals(cart) {
    var subtotal = 0, discount = 0;

    (cart.items || []).forEach(function (item) {
      var original = (typeof item.original_line_price === 'number')
        ? item.original_line_price
        : item.price * item.quantity;
      subtotal += original;

      var raw = (item.properties && item.properties._tamwaj_tiers) ||
                (cart.attributes && cart.attributes._tamwaj_tiers);
      var tier = tierFor(parseTiers(raw), item.quantity);
      if (tier && tier.discount > 0) {
        /* نقرّب المبلغ المستحق ثم نشتقّ الخصم منه — لا العكس.
           هكذا يطابق الرقم ما يعرضه الودجت في صفحة المنتج. */
        var target = priced(original * (1 - tier.discount / 100), parseMode(raw));
        discount += (original - target);
      }
    });

    discount = Math.round(discount);
    return { subtotal: subtotal, discount: discount, total: subtotal - discount };
  }

  /* العنصر الذي يقرأ منه Releasit خصمًا ثابتًا بالسنت */
  function syncCodDiscount(cents) {
    var el = document.getElementById('awesome-quantity-data');
    if (!el) {
      el = document.createElement('div');
      el.id = 'awesome-quantity-data';
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
      (document.body || document.documentElement).appendChild(el);
    }
    el.setAttribute('data-applied-discount', String(Math.max(0, cents)));
  }

  var writing = false;   /* يمنع ملاحظ التغيّر من ملاحقة تعديلاتنا */

  function putRow(parent, before, cls, extraCls, label, value) {
    var el = parent.querySelector('.' + cls);
    if (!el) {
      el = document.createElement('p');
      el.className = cls + (extraCls ? ' ' + extraCls : '');
      parent.insertBefore(el, before);
    }
    el.innerHTML = '<span class="TamwajCartRow__Label">' + label + '</span>' +
                   '<span class="TamwajCartRow__Value">' + value + '</span>';
  }

  function dropRow(parent, cls) {
    var el = parent.querySelector('.' + cls);
    if (el) el.remove();
  }

  function render(sums) {
    writing = true;

    /* صفحة السلة */
    document.querySelectorAll('.Cart__Recap').forEach(function (recap) {
      var totalEl = recap.querySelector('.Cart__Total');
      if (!totalEl) return;

      if (sums.discount <= 0) {
        dropRow(recap, 'TamwajCartSub');
        dropRow(recap, 'TamwajCartSave');
      } else {
        /* بلا سطر المجموع تبدو الأرقام غلطًا: سعر القطعة، ثم خصم،
           ثم إجمالي لا يطرح أحدهما من الآخر أمام العين. */
        putRow(recap, totalEl, 'TamwajCartSub', 'Heading u-h6',
               'المجموع', formatMoney(sums.subtotal));
        putRow(recap, totalEl, 'TamwajCartSave', 'Heading u-h6',
               'خصم العرض', '− ' + formatMoney(sums.discount));
      }

      var money = totalEl.querySelector('[data-money-convertible]');
      if (money) money.textContent = formatMoney(sums.total);
    });

    /* الدرج الجانبي: لا Cart__Recap فيه، ومبلغه داخل زر الطلب */
    document.querySelectorAll('.Drawer__Footer').forEach(function (footer) {
      var cta = footer.querySelector('.TamwajDrawerCta');
      if (!cta) return;

      if (sums.discount <= 0) {
        dropRow(footer, 'TamwajCartSub');
        dropRow(footer, 'TamwajCartSave');
      } else {
        putRow(footer, cta, 'TamwajCartSub', '', 'المجموع', formatMoney(sums.subtotal));
        putRow(footer, cta, 'TamwajCartSave', '', 'خصم العرض', '− ' + formatMoney(sums.discount));
      }

      var money = cta.querySelector('[data-money-convertible]');
      if (money) money.textContent = formatMoney(sums.total);
    });

    setTimeout(function () { writing = false; }, 60);
  }

  var pending = null;

  function refresh() {
    if (writing) return;
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch(ROOT.replace(/\/$/, '') + '/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var sums = totals(cart);
          syncCodDiscount(sums.discount);
          render(sums);
        })
        .catch(function () { /* السلة غير متاحة — نترك الأرقام كما هي */ });
    }, 220);
  }

  var onCartPage = document.body && document.body.className.indexOf('template-cart') !== -1;

  function start() {
    if (!document.querySelector('.Cart__Recap') && !document.getElementById('sidebar-cart')) return;
    refresh();

    if (onCartPage) {
      /* تغيير الكمية أو الحذف: تحميل كامل للصفحة.
         أزرار الكمية أصلًا روابط إلى /cart/change، فنترك المتصفّح
         يتبعها بدل أجاكس الثيم. الأرقام تُبنى من الخادم فلا تتأخّر
         ولا تتضارب، والصفحة لا تحمل مراقب تغيّر يعيد الحساب.

         المراقب السابق كان يوقظ tamwaj-money.js الذي يوقظه بدوره —
         حلقة جعلت الصفحة ثقيلة. */
      document.addEventListener('click', function (event) {
        var t = event.target;
        if (!t || !t.closest) return;
        var link = t.closest('a[data-action="update-item-quantity"], a[data-action="remove-item"]');
        if (!link || !link.getAttribute('href')) return;

        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

        document.documentElement.classList.add('tamwaj-cart-busy');
        window.location.href = link.href;
      }, true);
      return;
    }

    /* خارج صفحة السلة يبقى الدرج: نحدّثه دفعات محدودة بعد الإضافة
       أو فتحه — بلا مراقبة دائمة. */
    document.addEventListener('click', function (event) {
      var t = event.target;
      if (!t || !t.closest) return;
      if (!t.closest('[data-action="add-to-cart"]') &&
          !t.closest('[data-drawer-id="sidebar-cart"]') &&
          !t.closest('a[data-action="update-item-quantity"]') &&
          !t.closest('a[data-action="remove-item"]')) return;
      setTimeout(refresh, 700);
      setTimeout(refresh, 1800);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
